// 解析 specifiers 字符串
const parseSpecifiers = specifiers => {
  let tmp = specifiers.split('|')
  tmp = tmp[0]
  tmp = tmp.split('=')
  tmp = tmp[1]
  return tmp
}

const sortBySpecifiers = markets => markets.sort((a, b) => {
  if (a.specifiers && b.specifiers) {
    const tmp = parseSpecifiers(a.specifiers)
    const tmp1 = parseSpecifiers(b.specifiers)
    return tmp - tmp1
  }
  return false
})

const sortMarkets = markets => {
  const specifiersList = []
  let name
  // 不要改变原数组
  const sortedMarkets = sortBySpecifiers([...markets])
  // 对market排序
  for (let i = 0; i < sortedMarkets.length; i++) {
    const market = sortedMarkets[i]
    // 锁哥specifiers用|隔开，每个speifier是用=隔开
    let tmp = market.specifiers.split('|')
    tmp = tmp[0]
    const ss = tmp.split('=')
    specifiersList.push(ss[1])
    // 每个specifiers都是类似  goals=1.5这种,所以多次赋值也可以
    name = ss[0]
  }
  return {
    markets: sortedMarkets,
    specifiersList,
    name
  }
}

export default sortMarkets
